<template>
  <div class="relative">
    <div class="grid" style="grid-template-columns: 1fr 360px; height: 67vh;">
      <div class="relative">
        <!-- 네이버 지도 -->
        <div id="map" style="width:100%; height:100%;"></div>

        <!-- 레이어 -->
        <div style="position: absolute; bottom: 15px; left: 15px; background-color: #fff; border: 1px solid #CDCDCD; border-radius: 10px;">
          <div class="grid">
            <span v-for="(layer, index) in layerList" :key="`layer_${layer}`"
                 class="px-4 py-2 text-center cursor-pointer"
                 :class="[index !==0 && 'border-top']"
                 style="font-weight: 500; color:#696D71"
                 :style="filter.selectLayer === layer ? {
                   backgroundColor: '#E2E0FA',
                   borderTopLeftRadius: index === 0 ? '10px' : '0px',
                   borderTopRightRadius: index === 0 ? '10px' : '0px',
                   borderBottomLeftRadius: index === layerList.length -1 ? '10px' : '0px',
                   borderBottomRightRadius: index === layerList.length -1 ? '10px' : '0px'
                 } : {}"
                  @click="() => {
                   filter.selectLayer = layer
                   updateOverlays();
                 }"
            >
              {{ layer }}
            </span>
          </div>
        </div>

        <!-- 현황 보기 -->
        <div v-if="isShowOverlaysDetail" class="py-6 absolute top-0 right-0 bottom-0"
             style="width: 360px; background: #fff; border: 1px solid #cdcdcd; z-index: 101; display: grid; grid-template-rows: auto auto 1fr;">
          <div class="px-6">
            <h3 class="mb-4 px-2 flex items-center border-bottom" style="font-size: 1.25rem; height: 64px;">
              <span class="flex-1">{{ serializeData.종류 === 'region' ? $t('위험구역 정보') : $t('위험설비 정보') }}</span>
              <span class="ml-auto flex items-center cursor-pointer" @click="hideOverlayDetailData" >
                <feather-icon icon="XIcon"/>
                <span style="font-size:14px; font-weight: 500; color:#696D71;">{{ $t('닫기') }}</span>
              </span>
            </h3>
          </div>

          <div class="mt-3 px-6 overflow-y-auto">
            <div class="border-top border-bottom">
              <div class="border-bottom" style="display: grid; grid-template-columns: 120px 1fr">
                <span class="p-3" style="background: #FAFAFA">{{ serializeData.종류 === 'region' ? $t('구역 이름') : $t('설비 이름') }}</span>
                <span class="p-3">{{ serializeData.구역이름 }}</span>
              </div>
              <div class="border-bottom" style="display: grid; grid-template-columns: 120px 1fr">
                <span class="p-3" style="background: #FAFAFA">{{ serializeData.종류 === 'region' ? $t('구역 설명') : $t('설비 설명') }}</span>
                <span class="p-3 whitespace-pre-wrap">{{ serializeData.구역설명 }}</span>
              </div>
<!--              <div class="border-bottom" style="display: grid; grid-template-columns: 120px 1fr">-->
<!--                <span class="p-3" style="background: #FAFAFA">{{ $t('알림 종류') }}</span>-->
<!--                <span class="p-3">{{ serializeData.알림종류 }}</span>-->
<!--              </div>-->
              <div style="display: grid; grid-template-columns: 120px 1fr">
                <span class="p-3" style="background: #FAFAFA">{{ $t('접근인원') }}</span>
                <span class="p-3">{{ serializeData.접근인원 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 사업장 현황 -->
      <div class="py-6 h-full grid overflow-hidden" style="background: #fff; border: 1px solid #cdcdcd; grid-template-rows: auto auto 1fr auto">
        <div class="mb-4 px-6">
          <div class="pb-4 border-bottom">
            <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1.25rem;">{{ projectId === 5 ? this.$t('시설물 현황') : this.$t('사업장 현황') }}</h3>
            <vs-select autocomplete class="w-full" v-model="filter.field_id" @change="onSelectField">
              <vs-select-item v-for="field in [{ value:'', field_name: this.$t('전체') }, ...fields]" :key="`field_${field.id}`" :value="field.id" :text="field.field_name"/>
            </vs-select>
          </div>
        </div>
        <div>
          <div class="px-6 mb-6 flex gap-4">
            <vs-button class="flex-1 py-2 px-9" type="border" @click="onClickButton('위험구역')">{{ $t('위험구역') }}</vs-button>
            <vs-button class="flex-1 py-2 px-9" type="border" @click="onClickButton('위험설비')">{{ $t('위험설비') }}</vs-button>
          </div>
        </div>

        <div class="scroll-container px-6 grid gap-2 overflow-y-auto relative" style="grid-auto-rows: min-content">
          <ul class="info-body-data">
            <li v-for="(item, index) in filterOverlayDatas" :key="`region_${index}`" @click.stop.prevent="onClickItem(item)">
              <div class="info">
                <span class="icon" style="border-style: solid; border-width: 2px;" :style="{backgroundColor: item.ui.fillColor, borderColor:item.ui.strokeColor}"></span>
                <span>{{ item.data.text }}</span>
                <span class="ml-auto">{{ $t('num 명', { num: 0 }) }}</span>
              </div>
            </li>
          </ul>
          <div class="line"></div>
          <ul class="info-body">
            <li>
              <div class="info">
                <span class="icon" :style="{backgroundColor: '#535767'}"></span>
                <span>{{ $t('총 투입인원') }}</span>
                <span class="ml-auto">{{ $t('num 명', { num: 0 }) }}</span>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import FATabs from "@/components/FATabs.vue";
import * as DataUtil from "@/util/DataUtil";
import * as UiUtil from "@/util/UiUtil";
import HttpRequest from "@/util/HttpRequest";
import DrawingHandler, {DrawingSerialize} from "@/views/project/maps/employee-location/drawing-handler";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  name: 'ProjectMap',
  components: {FieldSelector, FATabs },
  props: {

  },
  computed: {
    yearList () {
      const list = []
      for (let i=0; i<3; i++) {
        const year = new Date().getFullYear() - i
        list.push(year)
      }
      return list
    },
    serializeData() {
      let 알림종류 = '';
      if (this.selectSerialize && this.selectSerialize.data) {
        if (this.selectSerialize.data.eventType === 'enter') {
          알림종류 = this.$t('진입 시 알림');
        } else if (this.selectSerialize.data.eventType === 'overstay') {
          const 분 = this.selectSerialize.data.stayTime.split(':')[1];
          알림종류 = `${this.$t('체류 시간 초과 시 알림')} - ${this.$t('n 분', {n: 분})}`;
        }
      }
      return {
        "종류": this.selectSerialize ? this.selectSerialize.data.type : 'region',
        "구역이름": this.selectSerialize ? this.selectSerialize.data.text : '',
        "구역설명": this.selectSerialize ? this.selectSerialize.data.description : '',
        "알림종류": 알림종류,
        "접근인원": 0,
      }
    },
    companyList() {
      return this.companyListAll.filter(item => {
        const projectList = item.project.filter(project => {
          return parseInt(project.pivot.project_id) === parseInt(this.projectId) && parseInt(project.pivot.depth) === parseInt(this.depth)
        })
        return projectList.length > 0 ;
      });
    },
    filterOverlayDatas () {
      return this.overlayDataList.filter(serialize => this.__checkFilter(serialize));
    }
  },
  data() {
    return {
      mapOptions: undefined,
      map: undefined,
      mapHandler: undefined,
      layerList: ['2','1','B1'],
      regions: [], // 위험구역 목록
      zones: [], // 위험설비 목록
      overlays: [],
      overlayDataList: [],
      fields: [],
      filter:{
        field_id: null,
        showRegion: true,
        selectLayer: '1',
      },
      markers: [],
      isShowOverlaysDetail: false,
      selectSerialize: undefined, // 선택된 도형(위험구역 or 위험설비)
      fieldSearchYear: new Date().getFullYear(),
      companyListAll: [], // 해당 분야의 모든 회사 목록
      openedInfoWindow: undefined, // 지도에 활성화 되어 있는 정보창

      projectId: 2,
      depth: 2,
      openCompany: null, // 현재 열려있는 필드
      openFieldGroup: null, // 현재 열려있는 필드 그룹
    };
  },
  methods: {
    hideOverlayDetailData () {
      this.isShowOverlaysDetail = false;
    },
    async initMap(lat, lng) {
      if (this.mapHandler) return;
      this.map = await new naver.maps.Map('map', {
        center: await new naver.maps.LatLng(lat || 35.0123653, lng || 128.24616394999998),
        zoom: 12,
        // 확대/축소 컨트롤러 옵션
        zoomControl: true,
        zoomControlOptions: {
          position: naver.maps.Position.RIGHT_BOTTOM // 위치 조정 가능
        }
      });
      this.mapHandler = new DrawingHandler(this.map, {
        readonly: true,
      });
      this.mapHandler.addedOverlay = (overlay, serialize) => {
        this.overlays.push(overlay)
        this.overlayDataList = this.mapHandler.getOverlaysSerialize();
      }
      this.mapHandler.changedOverlayPosition = (overlay, serialize) => {
        console.log("도형 위치 변경", serialize)
      }
      this.mapHandler.setSelectOverlay = (overlay, serialize) => {
        this.selectSerialize = serialize;
        if (serialize) {
          this.isShowOverlaysDetail = true;
          const latlng = new naver.maps.LatLng(serialize.ui.baseCenter.lat, serialize.ui.baseCenter.lng)
          this.map.setCenter(latlng);
        } else {
          this.isShowOverlaysDetail = false
        }
      }

      naver.maps.Event.once(this.map, 'init', () => {
        this.drawingManager = this.mapHandler.drawingManager;

        document.getElementById("btn-hand").addEventListener("click", () => {
          this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.HAND);
        });
        document.getElementById("btn-rect").addEventListener("click", () => {
          this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.RECTANGLE);
        });
        document.getElementById("btn-ellipse").addEventListener("click", () => {
          this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.ELLIPSE);
        });
        document.getElementById("btn-poly").addEventListener("click", () => {
          this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.POLYGON);
        });
      });
    },
    filterMarkers() {
      if (this.openedInfoWindow) this.openedInfoWindow.close();
      this.markers.forEach(marker => {
        if (this.openCompany) {
          const fieldIds = this.openCompany.fields.map(field => field.id);
          if (fieldIds.includes(marker.field_id)) {
            marker.setMap(this.map);
          } else {
            marker.setMap(null);
          }
        } else if (this.openFieldGroup) {
          const fieldIds = this.openFieldGroup.fields.map(field => field.id);
          if (fieldIds.includes(marker.field_id)) {
            marker.setMap(this.map);
          } else {
            marker.setMap(null);
          }
        } else {
          marker.setMap(this.map);
        }
      });
    },
    cleanMarkers() {
      if (this.openedInfoWindow) this.openedInfoWindow.close();
      this.markers.forEach(marker => {
        marker.setMap(null);
      });
      this.markers = [];
    },

    addMarker(field_id, lat, lng, title) {
      const marker = new naver.maps.Marker({
        map: this.map,
        position: new naver.maps.LatLng(lat, lng) //37.5666805, 126.9784147
      });
      marker.field_id = field_id;
      this.markers.push(marker)
    },
    async apiLoadRegion() {
      try {
        const option = {params: {}}
        const api = '/api/v1/region';
        const response = await HttpRequest.get(api, option).catch(err => {  })
        if (response.data && response.data.length > 0) {
          response.data.forEach(region => {
            const overlayData = JSON.parse(region.meta)
            overlayData.data.type = 'region';
            overlayData.data.id = region.id;
            if (region.name) overlayData.data.text = this.$t(region.name);
            if (region.description) overlayData.data.description = this.$t(region.description);
            this.regions.push(overlayData)
            this.mapHandler.addOverlay(overlayData)
          })
        }
      } catch (error) {
        console.log("apiLoadRegion error", error)
      }
    },

    async apiLoadZone() {
      try {
        const option = {params: {}}
        const api = '/api/v1/zone';
        const response = await HttpRequest.get(api, option).catch(err => {  })
        if (response.data && response.data.length > 0) {
          response.data.forEach(zone => {
            const overlayData = JSON.parse(zone.meta)
            overlayData.data.type = 'zone';
            overlayData.data.useBarrierOverlay = false;
            overlayData.data.id = zone.id;
            overlayData.data.fieldId = this.regions.filter(region => region.data.id === zone.region_id)[0].data.fieldId;
            this.zones.push(overlayData)
            this.mapHandler.addOverlay(overlayData)
          })
        }
      } catch (error) {
        console.log("apiLoadZone error", error)
      }
    },
    getLocation(successCallback, errorCallback) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          successCallback,
          errorCallback
        );
      } else {
        this.errorMessage = this.$t("이 브라우저에서는 위치 정보를 지원하지 않습니다.")
      }
    },
    onClickButton (key) {
      if (key === '위험구역') {
        this.filter.showRegion = true;
      } else if (key === '위험설비') {
        this.filter.showRegion = false;
      }
      this.updateOverlays();
    },
    onClickItem (serialize) {
      this.selectSerialize = serialize
      this.isShowOverlaysDetail = true;
      if (serialize.ui.baseCenter) {
        const latlng = new naver.maps.LatLng(serialize.ui.baseCenter.lat, serialize.ui.baseCenter.lng)
        this.map.setCenter(latlng);
      }

    },
    onSelectField () {
      this.updateOverlays();
    },
    updateOverlays() {
      this.overlays.forEach(overlay => {
        if (this.__checkFilter(overlay.serialize)) {
          overlay._marker.setMap(this.map);
          overlay.setMap(this.map);
        } else {
          overlay._marker.setMap(null);
          overlay.setMap(null);
        }

      });
    },
    // filter 조건에 일치하는지 체크
    __checkFilter(serialize) {
      let show = false;
      // 사업장을 선택하지 않을 경우
      if (!this.filter.field_id) show = true;
      // 선택한 사업장과 도형의 사업장이 일치할 경우
      else if (serialize.data.fieldId === this.filter.field_id) show = true;

      if (this.filter.selectLayer === '1') {
        show = !serialize.data.etc || serialize.data.etc.layer === '1' || !serialize.data.etc.layer;
      } else {
        if (!serialize.data.etc) show = false;
        else show = serialize.data.etc.layer === this.filter.selectLayer;
      }

      // 위험구역을 선택했을 경우
      if (this.filter.showRegion && serialize.data.type === 'zone') show = false;
      // 위험설비를 선택했을 경우
      if (!this.filter.showRegion && serialize.data.type === 'region') show = false;
      return show;
    },

    async loadFieldListAll() {
      const fieldParams = {
        projectId: this.projectId,
        page: 1,
        perPage: 50,
        showAll: true, // 참여여부와 상관없이 모든 사업장 조회
        withAddress: true, // field_address (다음지도에서 제공해주는 주소정보)
      };
      this.fields = await DataUtil.loadDefragmentation(this.$store, "project/LOAD_FIELD_LIST", fieldParams);
    },
  },

  async mounted() {
    await this.initMap();
    await this.apiLoadRegion();
    await this.apiLoadZone();
    await this.loadFieldListAll();
    this.updateOverlays();
    this.getLocation((position) => {
      this.addMarker(position.coords.latitude, position.coords.longitude);
    }, () => {
      console.error("위치 정보를 가져오는 데 실패했습니다.");
    });

  }
}

</script>

<style scoped lang="scss">
.data-item {
  .data-item-label,
  .data-item-value {
    display: block;
    padding: 14px;
    border-bottom: 1px solid #cdcdcd;
  }
}
.data-item-label {
  background: #FAFAFA;
}
.data-item-company {
  background-color: #fff;
  font-size: 16px;
  position:sticky;
  z-index: 1;
  top:0;

  &:hover {
    background-color: #f9f9f9;
  }
}
.data-item-field {
  span {
    display: block;
    padding-left: 1em; // 들여쓰기 효과
    position: relative;

    &::before {
      content: '-';
      position: absolute;
      left: 0;
    }
  }
  &:hover {
    background-color: #efefef;
  }
}
.data-group1 {
  border-top: 1px solid #cdcdcd;
  .data-item {
    display: grid;
    grid-template-columns: 100px 1fr;
  }
}
.data-group2 {
  margin-top: 20px;
  border-top: 1px solid #cdcdcd;
  .data-item {
    display: grid;
    grid-template-columns: 164px 1fr;
  }
}
</style>

<style lang="scss">
.iw_inner_body {
  padding: 0.8rem;
  border-radius: 8px;
  background-color: #3E3E3E;

  color: #FFFFFF;
}
.iw_inner_arrow {
  margin-left: auto;
  margin-right: auto;
  margin-top: -2px;
  width: 24px;
  height: 16px;
  background: #3E3E3E;
  clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
}
.iw_inner_title {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  padding-bottom: 10px !important;
}

.iw_inner_p {
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 4px;
}
.iw_inner_p_sub {
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 4px;

  display: block;
  padding-left: calc(1em + 8px); // 들여쓰기 효과
  position: relative;

  &.first {
    margin-top: 1rem !important;
  }
  &::before {
    content: '·';
    position: absolute;
    left: 0;
    padding-left: 8px;
  }
}
.iw_inner_btn {
  margin-top: 10px;
  padding: 4px;
  border: 1px solid #CDCDCD;
  border-radius: 4px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
.info-body,
.info-body-data {
  li > .info {
    display: flex;
    align-items: center;
    padding: 0.375rem 0;
    .icon {
      width: 20px;
      height: 20px;
      background-color: #E6E9F4;
      border-radius: 5px;
      margin-right: 1rem;
    }
  }
}
.info-body-data {
  li {
    cursor: pointer;
    &:hover {
      background-color: #F5F6FA;
    }
  }
}
.line {
  border-top: 1px solid #E6E9F4;
}
</style>
